import axios from "axios";

import { BlockDetailItem } from "components/forms/BlockDetail";

export const createBuildingStructure = async (
  token: string,
  rootSpace: string,
  blockData: Array<BlockDetailItem>
) => {
  const formattedBlocks = blockData.map(
    ({ name, pavementList, obs, pictures }) => ({
      name,
      root_space_id: rootSpace,
      description: obs,
      floor: pavementList,
      pictures: pictures.filter((pic) => pic),
    })
  );
  return axios
    .post(
      `${process.env.REACT_APP_API_PATH}/building-structure`,
      {
        buildingStructures: formattedBlocks,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then(({ data }) => {
      return data;
    });
};
